export const ERROR_EVENTS = {
  ERROR_PAGE_LOADS: 'error_page_loads',
  ERROR_INLINE_MESSAGES: 'error_inline_messages',
};
